export const getSubventions = state => state.subvention.subventionsList;
export const getSubventionDetails = state => state.subvention.subventionDetails;
